import {z} from "zod";


export const GetRangeRequestSchema = z.object({
    r: z.string(),
    f: z.string(), // name of field
    filter: z.union([z.literal(0), z.literal(1)]),
    reset: z.literal('f'),
});
export interface GetRangeRequestType extends z.infer<typeof GetRangeRequestSchema> { }
// EXAMPLE: http://usgfk.nemo.indigo/index.php?action=rpc_colorGetRange&r=&f=c_dist_hiper&filter=0&reset=f


export const GetRangeResponseSchema = z.object({
    status: z.literal(1),
    reset: z.literal('f'),
    range: z.object({
        f: z.string(),
        r: z.null(),
        a: z.literal('MAX'),
        f_out: z.string(),
        c_min: z.number(),
        c_max: z.number(),
    })
});
export interface GetRangeResponseType extends z.infer<typeof GetRangeResponseSchema> { }
// EXAMPLE: {"status":1,"reset":"f","range":{"f":"c_dist_hiper","r":null,"a":"MAX","f_out":"c_dist_hiper","c_max":65138,"c_min":0}}


function getOnfulfilled(
    request: GetRangeRequestType,
    reject: (reason?: any) => void,
    resolve: (value: (PromiseLike<unknown> | unknown)) => void
) {
    return (data: GetRangeResponseType) => {
        try {
            GetRangeResponseSchema.parse(data);
        } catch (error) {
            console.debug('getRange, request', request);
            console.debug('getRange, response', data);
            console.error(`Error zod: ${error.message}`);
            reject(`Error zod: ${error.message}`);
        }
        if (data.status !== 1) {
            reject('Nie udało się pobrać danych z serwera. Spróbuj ponownie później');
        } else {
            resolve(data);
        }
    };
}

export class featureGetRange {

    public static async getRange(request: GetRangeRequestType): Promise<GetRangeResponseType> {
        return new Promise((resolve, reject) => {
            try {
                GetRangeRequestSchema.parse(request);
            } catch (error) {
                console.debug('getRange, request', request);
                console.error(`ZodError, ${error.message}`);
                reject(`Błąd na wejściu danych (getRange): ${error.message}`);
            }
            fetch('./index.php?action=rpc_colorGetRange&' + featureGetRange.convertRequestToURLSearchParams(request), {
                method: 'GET',
            }).then((response) => {
                return response.json();
            }).then(getOnfulfilled(request, reject, resolve)).catch((error) => {
                console.error('featureGetRange, getRange, error', error);
                reject('Błąd: ' + error);
            });
        });
    }

    private static convertRequestToString(request: GetRangeRequestType): {[key:string]: string} {
        // convert all values from request to string and save as new object
        let requestConvertedToString: { [key:string]: string} = {};
        Object.keys(request).forEach((key) => {
            requestConvertedToString[key] = request[key].toString();
        });
        return requestConvertedToString;
    }

    private static convertRequestToURLSearchParams(request: GetRangeRequestType): string {
        return new URLSearchParams(featureGetRange.convertRequestToString(request)).toString();
    }
}